export default "__VITE_ASSET__Bq9HD5ND__"